require('./bootstrap');
require('./core/axios');
import moment from 'moment';
import EventBus from "./event/eventbus";
window.EventBus = EventBus;



import IMC_CORE from './libs/sys/imc_common';
import {ConfirmIMC} from "./libs/sys/confirm";
window.confirm_imc = ConfirmIMC;

import store from './store/index'
window.v_store = store;

import {datePick} from './libs/datePick/datepick';
window.dLang = datePick;


store.dispatch('user/LOAD_USER');
store.dispatch('user/LOAD_TENDER_USER');

window.IMC_CORE = new IMC_CORE();
window.moment = moment;


window.IMC_CORE_CONST = Joomla.getOptions('IMC_CORE_CONST');

require('./components/shared/imc_app');
require('./components/base/header/header');
require('./components/contragent/user/base/init_components');



//CONTRAGENT
if(document.getElementById('applications')) {
    require('./components/contragent/tenders/base/init_componnets');
}

if(document.getElementById('tender_items')) {
    require('./components/contragent/tenders/base/init_componnets');
}

if(document.getElementById('tender_app')) {
    require('./components/contragent/tender/tender.js');
}


//Reduction
if(document.getElementById('reduction_item')) {
    require('./components/reduction/reduction.js');
}

//SALE
if(document.getElementById('sale_applications')) {
    require('./components/sale/applications/list/list.js');
}

if(document.getElementById('protocol_table')) {
    require('./components/sale/protocols/list/list.js');
}



if(document.getElementById('sale_tender_items')) {
    require('./components/sale/tenders/list/list.js');
}

if(document.getElementById('reductionInside')) {
    require('./components/sale/reduction/inside/reduction_inside.js');
}

if(document.getElementById('protocolInside')) {
    require('./components/sale/protocol/inside/protocolInside.js');
}

if(document.getElementById('protocol')) {
    require('./components/sale/protocol/create/protocolCreate.js');
}

if(document.getElementById('tender')) {
    require('./components/sale/tender/create/tenderCreate');
}

if(document.getElementById('tender_inside')) {
    require('./components/sale/tender/inside/tenderInside');
}

if(document.getElementById('users')) {
    require('./components/sale/users/list/list.js');
}

if(document.getElementById('contragent_files')) {
    require('./components/sale/users/profile/files/profile_files.js');
}

if(document.getElementById('contragent_info')) {
    require('./components/sale/users/profile/info/profile_info.js');
}

if(document.getElementById('contragent_action')) {
    require('./components/sale/users/profile/actions/profile_action.js');
}

if(document.getElementById('tender_app_sale')) {
    require('./components/sale/applications/inside/application_inside.js');
}

